'use client'

import Booking from '~/components/booking'

export default function BookingPage() {
  return <Booking />
}
